import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Modal, Table, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { kedoGet, kedoPost } from './kedoApi';

const KedoMchdPage = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();

    const load = async () => {
        setLoading(true);
        try {
            setRows((await kedoGet('/mchd')) || []);
        } catch (e) {
            message.error(e?.response?.data?.message || e.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, []);

    const onCreate = async values => {
        try {
            await kedoPost('/mchd', values);
            message.success('МЧД создана (черновик)');
            setOpen(false);
            form.resetFields();
            load();
        } catch (e) {
            message.error(e?.response?.data?.message || e.message);
        }
    };

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: 16
                }}
            >
                <div>
                    <h1 style={{ margin: 0, fontFamily: 'Georgia, serif' }}>МЧД</h1>
                    <div style={{ opacity: 0.7 }}>
                        Машиночитаемые доверенности — модель и привязка к подписи
                        (полный реестр ФНС — этап 3)
                    </div>
                </div>
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => setOpen(true)}
                >
                    Добавить
                </Button>
            </div>
            <div className="kedo-panel">
                <Table
                    rowKey="id"
                    loading={loading}
                    dataSource={rows}
                    columns={[
                        { title: 'ID', dataIndex: 'id', width: 70 },
                        { title: 'Название', dataIndex: 'title' },
                        { title: 'Номер', dataIndex: 'number' },
                        { title: 'ИНН доверителя', dataIndex: 'principal_inn' },
                        {
                            title: 'Представитель',
                            dataIndex: 'representative_fio'
                        },
                        { title: 'Статус', dataIndex: 'status', width: 110 }
                    ]}
                />
            </div>
            <Modal
                title="МЧД"
                open={open}
                onCancel={() => setOpen(false)}
                onOk={() => form.submit()}
                destroyOnClose
            >
                <Form layout="vertical" form={form} onFinish={onCreate}>
                    <Form.Item name="title" label="Название" initialValue="МЧД">
                        <Input />
                    </Form.Item>
                    <Form.Item name="number" label="Номер">
                        <Input />
                    </Form.Item>
                    <Form.Item name="principal_inn" label="ИНН доверителя">
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="representative_fio"
                        label="ФИО представителя"
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default KedoMchdPage;
